<template>
<div>
  <div class="row row-small mt-1">
    <div class="col-24 col-md-6">
      <contact-select name="salutation" :label="$t('Anrede')"  group="contact" values="Frau,Herr,Familie,Firma"></contact-select>
    </div>

    <div class="col-24 col-md-9">
      <contact-input name="lastname" :label="$t('Ihr Name')" group="contact"></contact-input>
    </div>

    <div class="col-24 col-md-9">
      <contact-input name="city" :label="$t('Standort')" group="contact"></contact-input>
    </div>

    <div class="col-24">
      <contact-input textarea name="message" group="contact" :label="$t('Ihre Meinung')"   class="testimonials-form__textarea"></contact-input>
    </div>
  </div>

  <div class="testimonials__rating d-flex">
    <label class="mr-1 mb-1 ">{{ $t('Ihre Bewertung') }}</label> <rating></rating>
  </div>
</div>
</template>

<script>
import ContactInput from "./ContactInput.vue";
import ContactSelect from "./ContactSelect.vue";
import Rating from "./TestimonialRating.vue";

export default {
  name: "TestimonialForm",

  components: {
    ContactInput,
    ContactSelect,
    Rating
  }
}
</script>
